<script setup lang="ts">
interface Props {
  collapsed?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  navigate: [path: string]
}>()

const menuItems = [
  { icon: '🏠', label: '项目大厅', path: '/' },
  { icon: '📝', label: '创业笔记', path: '/notes' },
  { icon: '✅', label: '任务', path: '/tasks' },
  { icon: '📋', label: '计划', path: '/plans' },
  { icon: '📅', label: '每日总结', path: '/summary' },
  { icon: '📁', label: '文件管理', path: '/files' },
]

const handleClick = (e: MouseEvent, path: string) => {
  e.preventDefault()
  emit('navigate', path)
}
</script>

<template>
  <div class="sidebar-content">
    <div class="logo">
      <span class="logo-icon">🚀</span>
      <span v-if="!collapsed" class="logo-text">创业笔记</span>
    </div>
    
    <nav class="menu">
      <a
        v-for="item in menuItems"
        :key="item.path"
        :href="'#' + item.path"
        class="menu-item"
        :title="collapsed ? item.label : ''"
        @click="handleClick($event, item.path)"
      >
        <span class="menu-icon">{{ item.icon }}</span>
        <span v-if="!collapsed" class="menu-label">{{ item.label }}</span>
      </a>
    </nav>
  </div>
</template>

<style scoped>
.sidebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  gap: 0.5rem;
}

.logo-icon {
  font-size: 1.5rem;
}

.logo-text {
  font-size: 1.2rem;
  font-weight: 600;
  color: #42b883;
}

.menu {
  flex: 1;
  padding: 1rem 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.2s;
  gap: 0.75rem;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.menu-icon {
  font-size: 1.2rem;
  width: 24px;
  text-align: center;
}

.menu-label {
  font-size: 0.9rem;
}
</style>
